var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNftbgbanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 667,
    height: 442,
    viewBox: "0 0 667 442",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135_1584)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 667,
    height: 442,
    fill: "#1E440B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-167.79 502C-79.1263 492.686 93.727 462.675 167.11 400.738C257.752 324.233 299.454 197.603 314.915 84.8279C317.626 65.0532 316.166 44.9238 317.411 25.0041C317.963 16.1789 316.05 6.39116 320.301 -1.36552C339.74 -36.8307 418.157 1.98926 434.605 12.4097C509.149 59.6364 582.559 155.962 562.964 248.686C555.726 282.941 533.003 313.303 541.812 349.572C545.071 362.989 563.981 417.65 586.351 407.166C603.372 399.188 618.962 379.061 628.79 365.84C672.777 306.649 702.018 239.882 734.685 174.301C743.598 156.405 768.102 104.16 786.448 86.9267C816.092 59.0819 850.14 84.1869 870.002 108.705C880.478 121.628 890.085 135.629 896.543 150.948C903.419 167.257 918.481 224.11 900.482 242.782C888.609 255.111 868.557 259.654 851.482 258.263C775.783 252.098 669.659 191.611 610.917 161.181C550.262 129.757 440.768 63.1271 369.701 38.7792C298.845 14.5032 217.53 26.3147 146.877 45.2076C101.807 57.2595 65.5465 73.1244 30.2098 103.719C-4.7322 133.972 -26.4662 174.893 -49.8027 213.658C-73.7115 253.375 -113.879 268.013 -153.2 288.962C-163.062 294.216 -169.927 297.932 -177.9 304.968C-179.511 306.389 -183.444 309.549 -181.447 310.346C-180.019 310.917 -178.366 310.211 -176.849 309.953C-141.247 303.902 -105.57 298.927 -69.9041 293.16C55.7054 272.852 187.779 255.526 301.514 195.159C313.845 188.616 310.265 189.387 312.419 206.443C320.443 269.971 321.789 336.844 336.856 399.163C341.289 417.503 345.744 436.946 357.089 452.033C379.873 482.333 414.324 475.323 445.772 472.237C562.964 472.237 607.728 391.643 648.486 381.37",
    stroke: "#929292",
    strokeOpacity: 0.16,
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_1584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 667,
    height: 442,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftbgbanner);
export default __webpack_public_path__ + "static/media/nftbgbanner.082eb1869554c604fce7aa106b6ea40b.svg";
export { ForwardRef as ReactComponent };